import { CSGOModel } from "../models/CSGOModel";
import API, { client } from "./API";

const CSGOService = {
  async getAllCSGOs() {
    const response = await API().get("CSGO", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularCSGO(csgo_id: number) {
    const response = await API().get("CSGO");
    return response.data.filter(
      (cur_csgo: CSGOModel) => cur_csgo.csgoid === csgo_id
    )[0];
  },
  async createCSGO(data: CSGOModel, id?: number) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `Csgo/${id}` : "Csgo",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default CSGOService;
